<template>
  <div id="app" class="container">
    <Header />
    <div v-if="alert.message" :class="`alert ${alert.type}`">
      {{ alert.message }}
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/common/Header.vue";

export default {
  name: "app",
  computed: {
    ...mapState({
      alert: (state) => state.alert,
      loggedin: (state) => {
        return state.account.user && state.account.user.ok;
      },
    }),
  },
  mounted() {
    this.$nextTick(() => {
      if (this.loggedin) {
        this.getVehicles();
        this.getSchedule();
        this.getCustomers();
        this.getPersonnels();
        this.getUsers();
        this.getPlantBotanys();
      }
    });
  },
  methods: {
    ...mapActions("schedule", ["getSchedule"]),
    ...mapActions("vehicles", ["getVehicles"]),
    ...mapActions("customers", ["getCustomers"]),
    ...mapActions("personnels", ["getPersonnels"]),
    ...mapActions("users", ["getUsers"]),
    ...mapActions("inventory", ["getPlantBotanys"]),
    ...mapActions({
      clearAlert: "alert/clear",
    }),
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearAlert();
    },
  },
  components: {
    Header,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
